import React from "react";
import styled from "@emotion/styled";

import LayerWrapper from "./LayerWrapper";

const InnerWrapper = styled.div`
  padding: 2px;
  position: relative;
  height: 100%;
`;

const Overlay = styled.div`
  ${(p) =>
    p.vertical
      ? `
    width: calc(${p.itemHeight}% - 1.33px);
    height: 100%;
    float: left;
    margin-right: 2px;
    &:last-of-type {
      margin-right: 0;
    }
  `
      : `
    width: 100%;
    height: calc(${p.itemHeight}% - 1px);
    margin-bottom: 2px;
    &:last-of-type {
      margin-bottom: 0;
    }
  `}
  border-style: solid;
  border-color: #222;
  border-width: ${(p) => (p.small ? 2 : 3)}px;
  background-color: ${(p) => {
    const bgColor = p.isBiden
      ? p.theme.colors.democraticReduced
      : p.theme.colors.republicanReduced;
    return p.fill ? bgColor : "rgba(0, 0, 0, 0)";
  }};
  border-color: ${(p) => {
    const bgColor = p.isBiden
      ? p.theme.colors.democratic
      : p.theme.colors.republican;
    return p.fill ? bgColor : p.theme.colors.black;
  }};
  transition: background-color 0.5s;
  position: relative;
`;
// ${(p) => p.theme.snippets.bulletedAfter(p.number)}

function isBidenWinner(i, vertical) {
  return vertical ? i < 1 : i <= 1;
}

const DistrictsOverlay = ({
  matrix,
  isBiden,
  fill,
  vertical = false,
  small = false,
}) => {
  const itemHeight = (1 / matrix.length) * 100;
  return (
    <LayerWrapper>
      <InnerWrapper>
        {matrix.map((row, i) => (
          <Overlay
            key={`overlay-${i}`}
            fill={fill}
            number={i + 1}
            isBiden={isBiden}
            vertical={vertical}
            small={small}
            itemHeight={itemHeight}
          />
        ))}
      </InnerWrapper>
    </LayerWrapper>
  );
};

DistrictsOverlay.defaultProps = {
  matrix: [
    [true, true, false],
    [true, true, false],
    [true, false, false],
  ],
};

export default DistrictsOverlay;
